<template>
  <div class="mapdata_filter_container">
    <div class="mapdata_filters_uppercontainer">
      <div class="mapdata_filter_innercontainer">
        <div class="mapdata_filter_title">
          {{ $t('dataSelectors.sale-market') }}
        </div>
        <div :class="askingsale.values.length > 0 ? '' : 'disabled-slider'" class="mapdata-filter-slider-container">
          <div class="mapdata-filter-slider-subtitle">{{ $t('dataSelectors.asking-sqm') }}</div>
          <dualRangeSlider :value="askingsale.values" :step="100" @input="changedInput(askingsale, ...arguments)" />
        </div>
        <div :class="newcon.values.length > 0 ? '' : 'disabled-slider'" class="mapdata-filter-slider-container">
          <div class="mapdata-filter-slider-subtitle">{{ $t('dataSelectors.asking-new-dev-sqm') }}</div>
          <dualRangeSlider :value="newcon.values" :step="100" @input="changedInput(newcon, ...arguments)" />
        </div>
        <div :class="trans.values.length > 0 ? '' : 'disabled-slider'" class="mapdata-filter-slider-container">
          <div class="mapdata-filter-slider-subtitle">{{ $t('dataSelectors.transactions-sqm') }}</div>
          <dualRangeSlider :value="trans.values" :step="100" @input="changedInput(trans, ...arguments)" />
        </div>
        <div :class="tts.values.length > 0 ? '' : 'disabled-slider'" class="mapdata-filter-slider-container">
          <div class="mapdata-filter-slider-subtitle">{{ $t('marketplace.time-sale') }}</div>
          <dualRangeSlider :value="tts.values" :step="1" @input="changedInput(tts, ...arguments)" />
        </div>
        <div :class="asking_var_yoy.values.length > 0 ? '' : 'disabled-slider'" class="mapdata-filter-slider-container">
          <div class="mapdata-filter-slider-subtitle">{{ $t('dataSelectors.asking-prices-growth-yoy') }}</div>
          <dualRangeSlider :value="asking_var_yoy.values" :step="1" @input="changedInput(asking_var_yoy, ...arguments)" />
        </div>
        <div class="mapdata_filter_title title-margin">
          {{ $t('map_rent-market') }}
        </div>
        <div :class="askingrent.values.length > 0 ? '' : 'disabled-slider'" class="mapdata-filter-slider-container">
          <div class="mapdata-filter-slider-subtitle">{{ $t('dataSelectors.asking-sqm-mo') }}</div>
          <dualRangeSlider :value="askingrent.values" :step="1" @input="changedInput(askingrent, ...arguments)" />
        </div>
        <div :class="ttr.values.length > 0 ? '' : 'disabled-slider'" class="mapdata-filter-slider-container">
          <div class="mapdata-filter-slider-subtitle">{{ $t('ttr') }}</div>
          <dualRangeSlider :value="ttr.values" :step="1" @input="changedInput(ttr, ...arguments)" />
        </div>
        <div :class="grossyield.values.length > 0 ? '' : 'disabled-slider'" class="mapdata-filter-slider-container">
          <div class="mapdata-filter-slider-subtitle">{{ $t('dataSelectors.gross-yield') }}</div>
          <dualRangeSlider :value="grossyield.values" :step="1" @input="changedInput(grossyield, ...arguments)" />
        </div>
        <div :class="asking_rent_var_yoy.values.length > 0 ? '' : 'disabled-slider'" class="mapdata-filter-slider-container">
          <div class="mapdata-filter-slider-subtitle">{{ $t('dataSelectors.asking-prices-growth-yoy') }}</div>
          <dualRangeSlider :value="asking_rent_var_yoy.values" :step="1" @input="changedInput(asking_rent_var_yoy, ...arguments)" />
        </div>
      </div>

      <div class="mapdata_filter_innercontainer">
        <div class="mapdata_filter_title">
          {{ $t('dataSelectors.socioeconomics') }}
        </div>
        <div :class="population_density.values.length > 0 ? '' : 'disabled-slider'" class="mapdata-filter-slider-container">
          <div class="mapdata-filter-slider-subtitle">{{ $t('dataSelectors.population-density') }}</div>
          <dualRangeSlider :value="population_density.values" :step="1" @input="changedInput(population_density, ...arguments)" />
        </div>
        <div :class="avg_age.values.length > 0 ? '' : 'disabled-slider'" class="mapdata-filter-slider-container">
          <div class="mapdata-filter-slider-subtitle">{{ $t('dataSelectors.avg-age') }}</div>
          <dualRangeSlider :value="avg_age.values" :step="1" @input="changedInput(avg_age, ...arguments)" />
        </div>
        <div :class="immigration_rate.values.length > 0 ? '' : 'disabled-slider'" class="mapdata-filter-slider-container">
          <div class="mapdata-filter-slider-subtitle">{{ $t('dataSelectors.inmigration-rate') }}</div>
          <dualRangeSlider :value="immigration_rate.values" :step="1" @input="changedInput(immigration_rate, ...arguments)" />
        </div>
        <div :class="variation_6y.values.length > 0 ? '' : 'disabled-slider'" class="mapdata-filter-slider-container">
          <div class="mapdata-filter-slider-subtitle">{{ $t('dataSelectors.one-year-population-var') }}</div>
          <dualRangeSlider :value="variation_6y.values" :step="1" @input="changedInput(variation_6y, ...arguments)" />
        </div>
        <div :class="variation_1y.values.length > 0 ? '' : 'disabled-slider'" class="mapdata-filter-slider-container">
          <div class="mapdata-filter-slider-subtitle">{{ $t('dataSelectors.six-year-population-var') }}</div>
          <dualRangeSlider :value="variation_1y.values" :step="1" @input="changedInput(variation_1y, ...arguments)" />
        </div>
        <div :class="avg_income.values.length > 0 ? '' : 'disabled-slider'" class="mapdata-filter-slider-container">
          <div class="mapdata-filter-slider-subtitle">{{ $t('dataSelectors.avg-household-income') }}</div>
          <dualRangeSlider :value="avg_income.values" :step="100" @input="changedInput(avg_income, ...arguments)" />
        </div>
        <div :class="unemployment_rate.values.length > 0 ? '' : 'disabled-slider'" class="mapdata-filter-slider-container">
          <div class="mapdata-filter-slider-subtitle">{{ $t('dataSelectors.unemployment-rate') }}</div>
          <dualRangeSlider :value="unemployment_rate.values" :step="1" @input="changedInput(unemployment_rate, ...arguments)" />
        </div>
        <div :class="default_rate.values.length > 0 ? '' : 'disabled-slider'" class="mapdata-filter-slider-container">
          <div class="mapdata-filter-slider-subtitle">{{ $t('dataSelectors.default-rate') }}</div>
          <dualRangeSlider :value="default_rate.values" :step="1" @input="changedInput(default_rate, ...arguments)" />
        </div>
        <div :class="squatters_risk.values.length > 0 ? '' : 'disabled-slider'" class="mapdata-filter-slider-container">
          <div class="mapdata-filter-slider-subtitle">{{ $t('dataSelectors.squatters-risk') }}</div>
          <dualRangeSlider :value="squatters_risk.values" :step="1" @input="changedInput(squatters_risk, ...arguments)" />
        </div>
        <div :class="aff_sale.values.length > 0 ? '' : 'disabled-slider'" class="mapdata-filter-slider-container">
          <div class="mapdata-filter-slider-subtitle">{{ $t('dataSelectors.purchase-effort') }}</div>
          <dualRangeSlider :value="aff_sale.values" :step="1" @input="changedInput(aff_sale, ...arguments)" />
        </div>
        <div :class="aff_rent.values.length > 0 ? '' : 'disabled-slider'" class="mapdata-filter-slider-container">
          <div class="mapdata-filter-slider-subtitle">{{ $t('dataSelectors.rent-effort') }}</div>
          <dualRangeSlider :value="aff_rent.values" :step="1" @input="changedInput(aff_rent, ...arguments)" />
        </div>
      </div>
    </div>
    <div class="mapdata_filters_footer">
      <div class="mapdata_filters_footer_right">
        <button class="brains-type3-btn mr-1" @click="clearMapFilters()"><font-awesome-icon icon="trash" /></button>
        <button class="brains-type1-btn" @click="applyMapFilters()">Apply Filters</button>
      </div>
    </div>
  </div>
</template>

<script>
import dualRangeSlider from '@/components/designComponents/dualRangeSlider'
import { _ } from 'vue-underscore'
import { mapState } from 'vuex'

export default {
  name: 'InvestmentFilter',
  components: { dualRangeSlider },
  data() {
    return {
      mapFilters: [],
      askingsale: {
        resi: 'asking_sale_residential',
        office: 'asking_sale_office',
        retail: 'asking_sale_retail',
        industrial: 'asking_sale_industrial',
        flag: false,
        values: [],
        valueUpd: []
      },
      newcon: {
        resi: 'newcon_residential',
        flag: false,
        values: [],
        valueUpd: []
      },
      trans: {
        resi: 'trans_sale_em2_residential',
        office: 'trans_sale_em2_office',
        retail: 'rans_sale_em2_retail',
        industrial: 'trans_sale_em2_industrial',
        flag: false,
        values: [],
        valueUpd: []
      },
      tts: {
        resi: 'tts_residential',
        office: 'tts_office',
        retail: 'tts_retail',
        industrial: 'tts_industrial',
        flag: false,
        values: [],
        valueUpd: []
      },
      asking_var_yoy: {
        resi: 'Asking_Var_YoY_Em2_resi',
        office: 'Asking_Var_YoY_Em2_office',
        retail: 'Asking_Var_YoY_Em2_retail',
        industrial: 'Asking_Var_YoY_Em2_ind',
        flag: false,
        values: [],
        valueUpd: []
      },

      askingrent: {
        resi: 'asking_rent_residential',
        office: 'asking_rent_office',
        retail: 'asking_rent_retail',
        industrial: 'asking_rent_industrial',
        flag: false,
        values: [],
        valueUpd: []
      },
      ttr: {
        resi: 'ttr_residential',
        office: 'ttr_office',
        retail: 'ttr_retail',
        industrial: 'ttr_industrial',
        flag: false,
        values: [],
        valueUpd: []
      },
      grossyield: {
        resi: 'grossyield_residential',
        office: 'grossyield_office',
        retail: 'grossyield_retail',
        industrial: 'grossyield_industrial',
        flag: false,
        values: [],
        valueUpd: []
      },
      asking_rent_var_yoy: {
        resi: 'Asking_rent_Var_YoY_Em2_resi',
        office: 'Asking_rent_Var_YoY_Em2_office',
        retail: 'Asking_rent_Var_YoY_Em2_retail',
        industrial: 'Asking_rent_Var_YoY_Em2_ind',
        flag: false,
        values: [],
        valueUpd: []
      },

      population_density: {
        id: 'Density_t',
        flag: false,
        values: [],
        valueUpd: []
      },
      avg_age: {
        id: 'AVGAge',
        flag: false,
        values: [],
        valueUpd: []
      },
      immigration_rate: {
        id: 'ImmigrationRate_t',
        flag: false,
        values: [],
        valueUpd: []
      },
      variation_6y: {
        id: 'Variation_t5_t',
        flag: false,
        values: [],
        valueUpd: []
      },
      variation_1y: {
        id: 'Variation_t1_t',
        flag: false,
        values: [],
        valueUpd: []
      },
      avg_income: {
        id: 'AVGIncomePerHousehold',
        flag: false,
        values: [],
        valueUpd: []
      },
      unemployment_rate: {
        id: 'UnemploymentRate',
        flag: false,
        values: [],
        valueUpd: []
      },
      default_rate: {
        id: 'IX_DefaultRate',
        flag: false,
        values: [],
        valueUpd: []
      },
      squatters_risk: {
        id: 'IX_SquatterRisk',
        flag: false,
        values: [],
        valueUpd: []
      },
      aff_sale: {
        id: 'Affordability_Sale',
        flag: false,
        values: [],
        valueUpd: []
      },
      aff_rent: {
        id: 'Affordability_Rent',
        flag: false,
        values: [],
        valueUpd: []
      }
    }
  },
  computed: {
    ...mapState('location', {
      geolevels: (state) => state.geolevels,
      geolevelselected: (state) => state.geolevelselected
    }),
    ...mapState('maps', {
      mapvisualizationval: (state) => state.selectedmap.mapvisualizationval
    }),
    typo: {
      get() {
        var typo = ''
        if (this.mapvisualizationval.toLowerCase().includes('resi')) { typo = 'residential' } else if (this.mapvisualizationval.toLowerCase().includes('office')) { typo = 'office' } else if (this.mapvisualizationval.toLowerCase().includes('retail')) { typo = 'retail' } else if (this.mapvisualizationval.toLowerCase().includes('ind')) { typo = 'industrial' } else { typo = 'residential' }
        return typo
      }
    }
  },
  watch: {
    geolevelselected: function() {
      this.mapFilters = []
      // this.$store.dispatch('maps/setmapfilters', this.mapFilters)
      this.getRangeData()
    }
  },
  mounted() {
    this.getRangeData()
  },
  methods: {
    applyMapFilters() {
      var vm = this
      var filteredData = _.filter(this.$data, function(item) { return item.flag })
      var mapfil = []
      filteredData.forEach(item => {
        var mapid = ''
        // si tiene propiedad id -> mapa socioeconomico (SIN TYPO)
        if (item.id !== undefined && item.id !== null) {
          mapid = item.id
        } else {
          if (vm.typo === 'residential' && item.resi !== undefined && item.resi !== null) { mapid = item.resi } else if (vm.typo === 'office' && item.office !== undefined && item.office !== null) { mapid = item.office } else if (vm.typo === 'industrial' && item.industrial !== undefined && item.industrial !== null) { mapid = item.industrial } else if (vm.typo === 'retail' && item.retail !== undefined && item.retail !== null) { mapid = item.retail } else { mapid = item.resi }
        }
        mapfil.push({
          id: mapid,
          values: item.valueUpd
        })
      })
      this.mapFilters = mapfil
      this.$store.dispatch('maps/setmapfilters', this.mapFilters)
    },
    changedInput(filterid, value) {
      filterid.flag = true
      filterid.valueUpd = value
    },
    clearMapFilters() {
      this.mapFilters = []
      this.$store.dispatch('maps/setmapfilters', this.mapFilters)
      this.getRangeData()
    },
    getRangeData() {
      var vm = this
      if (vm.geolevelselected === null || vm.mapvisualizationval === '') {
        return
      }
      if (vm.geolevels.filter((item) => item.level === 0)[0] === null || vm.geolevels.filter((item) => item.level === 0)[0] === undefined) { return }
      var query = {
        id: vm.typo,
        country: vm.geolevels.filter((item) => item.level === 0)[0].name,
        geolevelid: vm.geolevelselected.level
      }
      vm.$store.dispatch('maps/GetMapFiltersData', query).then((resp) => {
        vm.askingsale.flag = false
        vm.askingsale.values = resp.askingsale
        vm.newcon.flag = false
        vm.newcon.values = resp.newcon
        vm.trans.flag = false
        vm.trans.values = resp.trans
        vm.tts.flag = false
        vm.tts.values = resp.tts
        vm.asking_var_yoy.flag = false
        vm.asking_var_yoy.values = resp.asking_var_yoy

        vm.askingrent.flag = false
        vm.askingrent.values = resp.askingrent
        vm.ttr.flag = false
        vm.ttr.values = resp.ttr
        vm.grossyield.flag = false
        vm.grossyield.values = resp.grossyield
        vm.asking_rent_var_yoy.flag = false
        vm.asking_rent_var_yoy.values = resp.asking_rent_var_yoy

        vm.population_density.flag = false
        vm.population_density.values = resp.population_density
        vm.avg_age.flag = false
        vm.avg_age.values = resp.avg_age
        vm.immigration_rate.flag = false
        vm.immigration_rate.values = resp.immigration_rate
        vm.variation_6y.flag = false
        vm.variation_6y.values = resp.variation_6y
        vm.variation_1y.flag = false
        vm.variation_1y.values = resp.variation_1y
        vm.avg_income.flag = false
        vm.avg_income.values = resp.avg_income
        vm.unemployment_rate.flag = false
        vm.unemployment_rate.values = resp.unemployment_rate
        vm.default_rate.flag = false
        vm.default_rate.values = resp.default_rate
        vm.squatters_risk.flag = false
        vm.squatters_risk.values = resp.squatters_risk
        vm.aff_sale.flag = false
        vm.aff_sale.values = resp.aff_sale
        vm.aff_rent.flag = false
        vm.aff_rent.values = resp.aff_rent
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mapdata_filter_container {
  display: flex;
  flex-direction: column;
  width: 450px;
  height: 60vh;
  font-family: "Montserrat-Regular",sans-serif;
  background-color: white;
  border: 1px solid rgb(221, 221, 221);
  box-sizing: border-box;

  .mapdata_filters_uppercontainer {
    height: calc(100% - 40px);
    padding: 10px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    overflow: scroll;
  }

  .mapdata_filters_footer {
    height: 40px;
    width: 100%;
    border-top: 1px solid lightgrey;
    display: flex;
    padding: 4px;

    .mapdata_filters_footer_right {
      margin-left: auto;
      margin-right: 15px;
    }
  }

  .disabled-slider {
    pointer-events: none;
    opacity: 0.4;
  }

  .mapdata_filter_innercontainer {
    width: 45%;
    height: 100%;
  }
  .mapdata_filter_title {
    font-size: 16px;
    font-family: "Montserrat-SemiBold",sans-serif;
    border-bottom: 2px solid #1e3cff;
  }
  .title-margin {
    margin-top: 25px;
  }

  .mapdata-filter-slider-container {
    margin-top: 20px;
    width: 100%;

    .mapdata-filter-slider-subtitle {
      color: grey;
      font-size: 12px;
      margin-bottom: 4px;
    }
  }
}
</style>
